export default __webpack_public_path__ + "static/media/none.1ed21124.png";